import AskModal from '../common/AskModal';
import { useSelector } from 'react-redux';

const AskRemoveModal = ({ visible, onConfirm, onCancel }) => {
    const language = useSelector(state => state.language.language);
    const isKR = language === 'KR' ? true : false;
    const isJP = language === 'JP' ? true : false;
    const isEN = language === 'EN' ? true : false;
    
    return (
        <AskModal
            visible={visible}
            title={isKR ? '프로젝트 삭제' : isJP ? 'プロジェクトの削除' : isEN ? 'Remove Project' : ''}
            description={isKR ? '프로젝트를 삭제하시겠습니까?' : isJP ? 'プロジェクトを削除しますか？' : isEN ? 'Sure to Remove Project?' : ''}
            cancelText={isKR ? '취소' : isJP ? 'キャンセル' : isEN ? 'Cancel' : ''}
            confirmText={isKR ? '삭제' : isJP ? '削除' : isEN ? 'Remove' : ''}
            onConfirm={onConfirm}
            onCancel={onCancel}
        />
    );
};

export default AskRemoveModal;
